import React from "react";
import OptionsSelector$ from "@deosite/components-new/OptionsSelector";

import ColorSquare from "../selectables/ColorSquare";
import Pill from "../selectables/Pill";
import SelectNative from "@deosite/components-new/SelectInDialog";
import FormControl from "../formControls/FormControl";

const OptionsSelector = props => {
  const propsExt = {
    ...props,
    colorSquare: <ColorSquare />,
    pill: <Pill />,
    selectNative: <SelectNative />,
    formControl: <FormControl />
  };
  return <OptionsSelector$ {...propsExt} />;
};

export default OptionsSelector;
